import * as React from "react";
import { Chip, CircularProgress, IconButton, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TextField }
    from "@material-ui/core";
import { Race } from "src/api/model";
import HighlightOff from '@material-ui/icons/Forward';
import { Link } from "react-router-dom";
import ClearIcon from '@material-ui/icons/Clear';

export interface TableComponentProps {
    rutaMapa?: () => string;
    onFilterChange: (filter: string) => void;
    onPageNumChange: (pageNum: number) => void;
    onPageSizeChange: (pageSize: number) => void;
    onDateFromChangeVisit: (dateFrom: string) => void;
    onDateToChangeVisit: (dateTo: string) => void;
    handleClearFilters: () => void;
    dateFromVisit: string;
    dateToVisit: string;

    filter: string;
    data: Race[];
    totalItems: number;
    pageNum: number;
    pageSize: number;
}

export const TableVisitsComponent: React.Factory<TableComponentProps> = (props: any) => {
    // const handleFilterChange = (e: any) => {
    //     props.onFilterChange(e.target.value);
    // };
    const handleDateFromChange = (e: any) => {
        props.onDateFromChangeVisit(e.target.value);
    };
    const handleDateToChange = (e: any) => {
        props.onDateToChangeVisit(e.target.value);
    };

    const handlePageChange = (event: any, newPage: number) => {
        props.onPageNumChange(newPage);
    };

    const handleRowsPerPageChange = (event: any) => {
        props.onPageSizeChange(parseInt(event.target.value, 10));
    };

    const handleClearFilters = () => {
        props.handleClearFilters();
    };


    return (
        <>
            <div>
                {/* <TextField
                    autoComplete="new-password"
                    name="search"
                    value={props.filter}
                    id="searchName"
                    placeholder="Filtrar tabla"
                    onChange={handleFilterChange}
                    style={{ padding: 0 }}
                    autoFocus={true}
                /> */}
                <TextField
                    label="Fecha Desde"
                    type="datetime-local"
                    value={props.dateFromVisit}
                    onChange={handleDateFromChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    style={{ marginLeft: 10 }}
                />
                <TextField
                    label="Fecha Hasta"
                    type="datetime-local"
                    value={props.dateToVisit}
                    onChange={handleDateToChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    style={{ marginLeft: 10 }}
                />
                <IconButton onClick={handleClearFilters} aria-label="clear filters" style={{ marginLeft: 10 }}>
                    <ClearIcon />
                </IconButton>
            </div>
            < Table >
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <p style={{ margin: 0 }}>Acciones</p>
                        </TableCell>
                        <TableCell>Id</TableCell>
                        <TableCell>Cliente</TableCell>
                        <TableCell>Fecha de visita programada</TableCell>
                        <TableCell>Fecha visitada</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell>Observacion</TableCell>
                        <TableCell>Razón de Visita</TableCell>
                        <TableCell>Sucursal</TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.data ? (
                        props.data.length > 0 ? (
                            props.data.map((data: any, index: any) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        {
                                            <Link to={{
                                                pathname: `/visit/${data.id}`,
                                                state: { data }
                                            }}>
                                                <IconButton aria-label='Desabilitar' title='Ver'>
                                                    <HighlightOff />
                                                </IconButton>
                                            </Link>
                                        }
                                    </TableCell>
                                    <TableCell>{data.id}</TableCell>
                                    <TableCell>{data.client && data.client.user && data.client.user.name ? data.client.user.name : ''}</TableCell>
                                    <TableCell>{data.visitDateTime}</TableCell>
                                    <TableCell>{data.visitDate}</TableCell>
                                    <TableCell>
                                        {data.visitDate && data.visitDate !== '' && data.visited ? <Chip style={{ backgroundColor: 'green', color: 'white' }} label='Visitado'></Chip> : !data.visitDate && data.visited === false ? <Chip style={{ backgroundColor: 'orange', color: 'white' }} label="Cancelado"></Chip> : <Chip style={{ backgroundColor: 'blue', color: 'white' }} label="Pendiente"></Chip>}
                                    </TableCell>
                                    <TableCell>{data.obs}</TableCell>
                                    <TableCell>{data.visitReason ? data.visitReason.description : ''}</TableCell>
                                    <TableCell>{data.branch ? data.branch.company.name : ''}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={3}>Sin resultados</TableCell>
                            </TableRow>
                        )
                    ) : (
                        <CircularProgress />
                    )}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            count={props.data ? props.totalItems : 0}
                            page={props.pageNum}
                            rowsPerPage={props.pageSize}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handleRowsPerPageChange}
                        />
                    </TableRow>
                </TableFooter>
            </Table >
        </>
    );
};


// WEBPACK FOOTER //
// ./src/components/TableVisitsComponent.tsx